import __request__ from "routing/request";
export function trigger(JSONbody, requestOptions) {
  return __request__("POST", "/system/jobs", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function list(requestOptions) {
  return __request__("GET", "/system/jobs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function acknowledgeJob(jobId, requestOptions) {
  return __request__("DELETE", `/system/jobs/acknowledge/${jobId}`, null, {}, {
    "Accept": []
  }, requestOptions);
}
export function get(jobId, requestOptions) {
  return __request__("GET", `/system/jobs/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function cancel(jobId, requestOptions) {
  return __request__("DELETE", `/system/jobs/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
